import { FileType } from '../shared/models/file-item.model';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { LocService } from '../shared/shared-context/loc.service';
import { UserContextService } from '../shared/shared-context/user-context.service';
import { TemplatesConfigService } from '../shared/templates/templates-config.service';
import { WacStartConfigService } from './wac-start-config.service';

const scenarioIdParam = 'scenarioid=';
const originParam = 'lpOrigin=OFFICECOM-WEB.START';
const correlationIdParam = 'correlationId=';
const localeMarketParam = 'omkt=';
const disableSearchParam = 'ds=';
const clickTimeParam = 'ct=';

export function getMoreTemplatesUrl(app: FileType, locale: string, wacStartConfig: WacStartConfigService, capabilitiesService: CapabilitiesService, startupConfigService: ClientStartupConfigService, userContextService: UserContextService) {
    if (!wacStartConfig.config.moreTemplatesRedirectionEnabled) {
        return;
    }

    switch (app) {
        case FileType.Visio:
            if (capabilitiesService.capabilities.modernTemplatesPageEnabled) {
                return;
            }
            const startTime = Date.now();
            let moreTemplatesUrl = wacStartConfig.config.visioMoreTemplatesUrl;
            const disableSearchParamValue = userContextService.user.isGcc ? '1' : '0';
            moreTemplatesUrl = `${moreTemplatesUrl}&${originParam}&${correlationIdParam}${startupConfigService.config.sharedClientStartupContext.correlationId}&${localeMarketParam}${locale}&${disableSearchParam}${disableSearchParamValue}&${clickTimeParam}${startTime}`;
            const scenarioId = capabilitiesService.capabilities.scenarioId;
            if (scenarioId) {
                moreTemplatesUrl = `${moreTemplatesUrl}&${scenarioIdParam}${scenarioId}`;
            }
            return moreTemplatesUrl;
        default:
            return;
    }
}

export function shouldShowStartPageTemplates(app: FileType, locale: string, templatesConfigService: TemplatesConfigService): boolean {
    switch (app) {
        case FileType.Visio:
            return !templatesConfigService.config.visioUnsupportedTemplatesLocales.includes(locale);
        default:
            return true;
    }
}

export function getAnnouncementMarkup(locService: LocService, wacStartConfigService: WacStartConfigService, app: FileType): string | undefined {
    switch (app) {
        case FileType.Stream:
            const streamCrossLinkUrl = wacStartConfigService.config.streamCrossLinkUrl;
            const streamDocumentationUrl = wacStartConfigService.config.streamDocumentationUrl;
            return locService.format(locService[wacStartConfigService.config.streamPreviewString], streamDocumentationUrl, streamCrossLinkUrl);
        default:
            return;
    }
}
